import styled from 'styled-components';

const BackgroundBar = styled.div<{ steps: number }>`
  background-color: ${(props) => props.theme.colors.lightGray};
  border-radius: 12px;
  height: 24px;
  margin: 0 calc(${(props) => 100 / (props.steps - 1) / 2}% - ${(props) => props.theme.spacing.baseValue * 4 + 12}px);
  position: relative;
`;

export default BackgroundBar;
